import React from 'react'

type Props = {
  width?: number
  height?: number
}

export const SubscribeCardIconChecked = ({
  width = 12,
  height = 9,
  ...props
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 1L4.125 7.875L1 4.75"
        stroke="#F9FFF9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
